import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ActorCardCmp_Representative_Fragment = graphql(`
  fragment ActorCardCmp_Representative_Fragment on Representative {
    _id
    index
    personId
    contextualRoleIds
    typeIds
  }
`);

export type ActorCardCmp_Representative = ResultOf<
  typeof ActorCardCmp_Representative_Fragment
>;
